// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: gZEhwnQAfx2q6zBpBNhhDQ
// Component: z4RZ38M1hhuG
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  renderPlasmicSlot
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_collect_wise_draft.module.css"; // plasmic-import: gZEhwnQAfx2q6zBpBNhhDQ/projectcss
import sty from "./PlasmicPaymentSuccess.module.css"; // plasmic-import: z4RZ38M1hhuG/css
import Icon7Icon from "./icons/PlasmicIcon__Icon7"; // plasmic-import: hcK0vMCAdLKs/icon

createPlasmicElementProxy;

export const PlasmicPaymentSuccess__VariantProps = new Array();

export const PlasmicPaymentSuccess__ArgProps = new Array("amount", "date");

const $$ = {};

function PlasmicPaymentSuccess__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            plasmic_antd_5_hostless_css.plasmic_tokens,
            sty.root
          )}
        >
          <div
            data-plasmic-name={"previewBody"}
            data-plasmic-override={overrides.previewBody}
            className={classNames(projectcss.all, sty.previewBody)}
          >
            <div className={classNames(projectcss.all, sty.freeBox___4XQ1Q)}>
              <div
                data-plasmic-name={"rectangle"}
                data-plasmic-override={overrides.rectangle}
                className={classNames(projectcss.all, sty.rectangle)}
              >
                <div className={classNames(projectcss.all, sty.freeBox__veY75)}>
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__meShJ
                    )}
                  >
                    {"Payment Succeeded"}
                  </div>
                  <Icon7Icon
                    data-plasmic-name={"svg"}
                    data-plasmic-override={overrides.svg}
                    className={classNames(projectcss.all, sty.svg)}
                    role={"img"}
                  />
                </div>
                <div className={classNames(projectcss.all, sty.freeBox__zm7Yx)}>
                  {renderPlasmicSlot({
                    defaultContents: "$1,000",
                    value: args.amount,
                    className: classNames(sty.slotTargetAmount)
                  })}
                </div>
                <div className={classNames(projectcss.all, sty.freeBox__pmrUu)}>
                  {renderPlasmicSlot({
                    defaultContents: "On July 12, 2022",
                    value: args.date,
                    className: classNames(sty.slotTargetDate)
                  })}
                </div>
                <button
                  data-plasmic-name={"downloadReciept"}
                  data-plasmic-override={overrides.downloadReciept}
                  className={classNames(
                    projectcss.all,
                    projectcss.button,
                    sty.downloadReciept
                  )}
                  ref={ref => {
                    $refs["downloadReciept"] = ref;
                  }}
                >
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__cqgm2
                    )}
                  >
                    {"Download Receipt"}
                  </div>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: ["root", "previewBody", "rectangle", "svg", "downloadReciept"],
  previewBody: ["previewBody", "rectangle", "svg", "downloadReciept"],
  rectangle: ["rectangle", "svg", "downloadReciept"],
  svg: ["svg"],
  downloadReciept: ["downloadReciept"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicPaymentSuccess__ArgProps,
          internalVariantPropNames: PlasmicPaymentSuccess__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicPaymentSuccess__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicPaymentSuccess";
  } else {
    func.displayName = `PlasmicPaymentSuccess.${nodeName}`;
  }
  return func;
}

export const PlasmicPaymentSuccess = Object.assign(
  // Top-level PlasmicPaymentSuccess renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    previewBody: makeNodeComponent("previewBody"),
    rectangle: makeNodeComponent("rectangle"),
    svg: makeNodeComponent("svg"),
    downloadReciept: makeNodeComponent("downloadReciept"),
    // Metadata about props expected for PlasmicPaymentSuccess
    internalVariantProps: PlasmicPaymentSuccess__VariantProps,
    internalArgProps: PlasmicPaymentSuccess__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicPaymentSuccess;
/* prettier-ignore-end */
